<nav class="sidebar" aria-label="Navegação principal">
  <div class="sidebar__brand" aria-hidden="true">
    @if (logoPath() || logoMiniPath()) {
      <div class="sidebar__brand-logo-wrap" [class.sidebar__brand-logo-wrap--with-mini]="logoMiniPath()">
        @if (logoPath()) {
          <img class="sidebar__brand-logo" [src]="logoPath()" [alt]="brandName()" />
        }
        @if (logoMiniPath()) {
          <img class="sidebar__brand-logo sidebar__brand-logo--mini" [src]="logoMiniPath()" [alt]="brandName()" />
        }
      </div>
    } @else {
      <span class="sidebar__brand-mark"></span>
    }
  </div>

  <div class="sidebar__user">
    <ui-top-navbar-user-menu
      [userName]="userName()"
      (logoutRequested)="onLogoutRequested()"
    />
  </div>

  <ul nz-menu nzMode="inline" nzTheme="light" class="sidebar__menu">
    @if (hasMenuConfig()) {
      @for (entry of menuConfig(); track entry.id) {
        @if (isGroup(entry)) {
          <li nz-submenu [nzTitle]="entry.label" [nzIcon]="entry.icon ?? 'appstore'" [nzOpen]="hasActiveChild(entry)">
            <ul>
              @for (item of entry.children; track item.id) {
                <li
                  nz-menu-item
                  class="sidebar__item"
                  [nzSelected]="isActiveRoute(item.route)"
                  [nzDisabled]="item.enabled === false"
                  [attr.aria-current]="isActiveRoute(item.route) ? 'page' : null"
                  (click)="onMenuNavigate(item)"
                >
                  <span nz-icon [nzType]="item.icon ?? 'right-circle'" class="sidebar__item-icon"></span>
                  <span class="sidebar__label">{{ item.label }}</span>
                </li>
              }
            </ul>
          </li>
        } @else {
          <li
            nz-menu-item
            class="sidebar__item"
            [nzSelected]="isActiveRoute(entry.route)"
            [nzDisabled]="entry.enabled === false"
            [attr.aria-current]="isActiveRoute(entry.route) ? 'page' : null"
            (click)="onMenuNavigate(entry)"
            [title]="entry.label"
          >
            <span nz-icon [nzType]="entry.icon ?? 'right-circle'" class="sidebar__item-icon"></span>
            <span class="sidebar__label">{{ entry.label }}</span>
          </li>
        }
      }
    }
  </ul>
</nav>